<template>
	<div class="card" :class="classes">
		<div class="card-front" :style="{ transform: 'rotate(' + this.rotate + 'deg)' }">
			<div class="bg"></div>
			<div class="deco"></div>
			<div class="frame"></div>
			<div v-if="!card.hide_illustration" class="illustration"><div class="img"></div></div>
			<p v-if="card.type != 'monster' && card.type != 'boss' && card.type != 'end'" class="name">{{ card[lang].name }}</p>
			<div v-if="card.type != 'item' && card.type != 'biome' && card.type != 'place' && card.type != 'drop' && card.type != 'end'" class="value" :class="{ 'modifier-up': value_modifier > 0, 'modifier-down': value_modifier < 0 }">
				<span>{{ value }}</span>
			</div>
			<div class="bubble"></div>
		</div>
		<div class="card-back">
			
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'card',
	data: function() {
		return {
			rotate: 0
		}
	},
	props: [ 'card' ],
	computed: Object.assign(mapGetters([ 'lang', 'heal_card_modifier', 'shield_card_modifier', 'monster_card_modifier', 'gold_card_multiplier' ]), {
		classes: function() {
			var temp = [ this.card.type, this.card.animation ]

			if (this.card.hide_illustration) temp.push('no-illustration')

			if (this.card.type == 'monster') temp.push('card-' + this.card.biome + '-' + this.card.slug)
			else temp.push('card-' + this.card.slug)

			return temp
		},
		// src: function() {
			// if (this.card.type == 'monster') return require('@/assets/img/cards/monsters/' + this.card.biome + '/' + this.card.value + '.png')
			// return require('@/assets/img/cards/icons/' + this.card.slug + '.png')
		// },
		value_modifier: function() {
			if (this.card.type == 'heal') return this.heal_card_modifier
			if (this.card.type == 'shield') return this.shield_card_modifier
			if (this.card.type == 'monster') return this.monster_card_modifier
			if (this.card.type == 'gold') return (this.gold_card_multiplier * this.card.value)
			return 0
		},
		value: function() {
			var value = this.card.value + this.value_modifier
			if (value < 0) return 0
			return value
		}
	}),
	mounted: function() {
		this.rotate = (Math.round((Math.random() * 2 - 1) * 10) / 10)
		// this.card.value = Math.round(Math.random() * 11 + 1)
	}
}
</script>

<style lang="stylus">
@import '../../assets/css/app'
@import '../../assets/css/cards'
@import '../../assets/css/card-monsters'

.card
	display block
	width card_width
	height card_height
	color dark
	font-family PearSoda
	font-size 1.6rem
	&.monster
		.card-front
			.bg:before
				background-color purple
			.frame
				background-image url(../../assets/img/ui/card-frame-purple.png)
			.illustration
				// position absolute
				// left 3px
				// top 3px
				// right auto
				// bottom auto
				// overflow hidden
				// margin 0
				// width calc(100% - 6px)
				// height calc(100% - 6px)
				// border-radius 4px
				.img
					transform translate(-50%, -50%) scale(1)
	&.item
		.card-front
			color light
			box-shadow 0 0 8px @color
			border-radius 6px
			.bg
				background-color #d76c3b
				background-color darken(dark, 10%)
			.illustration .img
				margin-top -8px
			.deco
				background-image url(../../assets/img/ui/card-bg-deco-no-value.png)
			.frame
				background-image url(../../assets/img/ui/hero-frame.png)
	&.drop
		.card-front
			.illustration .img
				margin-top -8px
			.deco
				background-image url(../../assets/img/ui/card-bg-deco-no-value.png)
			.frame
				background-image url(../../assets/img/ui/hero-frame.png)
	&.heal
		.card-front
			.bg:before
				background-color red
			.frame
				background-image url(../../assets/img/ui/card-frame-red.png)
	&.shield
		.card-front
			.bg:before
				background-color gray
			.frame
				background-image url(../../assets/img/ui/card-frame-gray.png)
	&.place
		.card-front
			.bg
				background-color light
				background-color #f3d19f
			.deco
				background-image url(../../assets/img/ui/card-bg-deco-no-value-dark.png)
			.frame
				background-image url(../../assets/img/ui/chest-frame.png)
	&.biome, &.end
		.card-front
			.illustration
				.img
					margin-top -8px
					border-radius 6px
					&:after
						content ''
						position absolute
						left 0
						top 0
						right 0
						bottom 0
						background url(../../assets/img/ui/biome-frame.png) center center no-repeat
						background-size 100% 100%
			.deco
				background-image url(../../assets/img/ui/card-bg-deco-no-value.png)
			.frame
				background-image url(../../assets/img/ui/hero-frame.png)
	&.end
		.card-front
			box-shadow 0 0 16px light
			border-radius 6px
			.illustration .img
				margin-top 0
			.frame
				background-image url(../../assets/img/ui/light-frame.png)
	&.gold
		.card-front
			.bg:before
				background-color yellow
			.frame
				background-image url(../../assets/img/ui/card-frame-yellow.png)
	
	&.no-illustration
		.card-front
			.name
				top 50%
				transform translateY(-50%)
		
	.card-back
		display none
		position absolute
		left 0
		top 0
		right 0
		bottom 0
		border-radius 6px
		background darken(dark, 10%) url(../../assets/img/ui/card-back.png) center center no-repeat
		background-size 64px auto
		box-shadow inset 0 0 32px darken(dark, 10%)
	.card-front
		height 100%
		width 100%
		.bg
			position absolute
			left 2px
			top 2px
			right 2px
			bottom 2px
			border-radius 6px
			background card_bg_color
			&:before
				content ''
				position absolute
				right 0
				top 0
				width 50%
				height 100%
				opacity 0.05
			&:after
				content ''
				position absolute
				left 0
				top 0
				right 0
				bottom 0
		.deco
			position absolute
			left 0
			top 0
			right 0
			bottom 0
			background url(../../assets/img/ui/card-bg-deco.png) center center no-repeat
			background-size 100% 100%
		.frame
			display block
			position absolute
			left 0
			top 0
			right 0
			bottom 0
			background url(../../assets/img/ui/card-frame-yellow.png) center center no-repeat
			background-size 100% 100%
		.illustration
			position absolute
			left 3px
			top 3px
			right 3px
			bottom 3px
			overflow hidden
			.img
				position absolute
				left 50%
				top 50%
				transform translate(-50%, -50%) scale(2)
				background-image url(../../assets/img/cards.png)
				background-repeat no-repeat
		.name
			position absolute
			left 16px
			right 16px
			top calc(50% + 32px)
			text-align center
			line-height 1.2rem
		.value
			position absolute
			left 8px
			top 8px
			width 34px
			height 32px
			background-size 32px auto
			// background-color yellow
			font-size 3.2rem
			line-height 32px
			color dark
			text-align center
			text-shadow -1px -1px 0 card_bg_color, 1px 1px 0 card_bg_color, -1px 1px 0 card_bg_color, 1px -1px 0 card_bg_color,
				-2px -2px 0 card_bg_color, 2px 2px 0 card_bg_color, -2px 2px 0 card_bg_color, 2px -2px 0 card_bg_color
			&.modifier-up, &.modifier-down
				&:after
					content ''
					position absolute
					right -17px
					top 0px
					width 16px
					height 16px
					box-shadow 0 0 0 3px card_bg_color
					background card_bg_color url(../../assets/img/ui/icons.png) 0 -16px no-repeat
			&.modifier-down:after
				background-position -16px -16px
		.bubble
			position absolute
			left 50%
			top 15%
			width 32px
			height 32px
			margin-left -16px
			opacity 0
			transform scale(0)
			// transition 0.25s easeOutQuart
			background url(../../assets/img/ui/monster-attack-emote.png) top left no-repeat


.card
	&.monster-attack
		.card-front
			.bubble
				opacity 1
				animation bubble 0.75s easeOutQuart forwards
	&.loot
		transform scale(0)
		opacity 0
		animation loot 0.25s easeOutQuart forwards
		animation-delay 0.5s
	&.die
		animation die 0.55s easeOutQuart forwards



@keyframes die
	0%
		opacity 1
	50%
		opacity 1
	100%
		opacity 0

@keyframes loot
	100%
		opacity 1
		transform scale(1)

@keyframes bubble
	0%
		opacity 0
		transform scale(0)
	20%
		opacity 1
		transform scale(1.5)
	80%
		opacity 1
		transform scale(1.25)
	100%
		opacity 0
		transform scale(1)
		

</style>
